<ion-header>
    <ion-toolbar>
        <ion-title>{{ currentCategory ? currentCategory.name : ('category' | transloco) }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="main-content">
        <us-products></us-products>
    </div>
</ion-content>
